import { NgStyle } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, input } from '@angular/core';
import { AdminInBot } from '@shared/index';
import { getContrastColor, strToColor } from '@reflact/tsutil';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SocketAdminService } from '@shared-angular/services/socketadmin.service';

@Component({
  selector: 'app-admin-position-bubble',
  imports: [NgStyle, 
    TooltipModule
  ],
  templateUrl: './admin-position-bubble.component.html',
  styleUrl: './admin-position-bubble.component.scss'
})
export class AdminPositionBubbleComponent implements AfterViewInit, OnDestroy {
  public readonly position = input.required<string>();
  public readonly reinitBubblesAfterDelay = input<boolean>(false);

  protected displayableBubbles: number = 0;
  protected getContrastColor = getContrastColor;
  private resizeObserver!: ResizeObserver;
  private bubbleWrapper: HTMLElement | null = null;
  private bubbleColor: string[] = ["#e9967a", "#7fffd4", "#5f9ea0", "#ffe4c4", "#deb887", "#ff7f50"];

  constructor(protected socketAdminService: SocketAdminService) {
    this.createResizeObserver();
  }

  public strToColor(str: string): string {
    return strToColor(str);
  }
  public async ngAfterViewInit(): Promise<void> {
    if (this.reinitBubblesAfterDelay()) {
      await new Promise(r => setTimeout(r, 5));
      this.createResizeObserver();
    }
    this.bubbleWrapper = document.getElementById(this.position() + 'BubbleWrapper');
    if (this.bubbleWrapper) this.resizeObserver.observe(this.bubbleWrapper);
  }

  public ngOnDestroy(): void {
    if (this.bubbleWrapper) this.resizeObserver.unobserve(this.bubbleWrapper);
  }

  public createResizeObserver() {
    this.resizeObserver = new ResizeObserver((entry) => {
      if (entry[0]?.target.id === this.position() + 'BubbleWrapper') {
        const calculatedBubbles = Math.floor((entry[0].contentRect.width - 30) / 10);
        if (calculatedBubbles >= 0) {
          this.displayableBubbles = calculatedBubbles;
        } else {
          this.displayableBubbles = 0;
        }
      }
    });
  }

  public getAllAdminsInBot(): AdminInBot[] {
    return this.socketAdminService.adminsAreCurrentlyHere.filter(admins => admins.position == this.position());
  }

  public getVisibleAdminsInBot(): AdminInBot[] {
    if (this.socketAdminService.adminsAreCurrentlyHere.length > this.displayableBubbles) return this.socketAdminService.adminsAreCurrentlyHere.filter(admins => admins.position == this.position()).slice(0, this.displayableBubbles);
    return this.socketAdminService.adminsAreCurrentlyHere.filter(admins => admins.position == this.position());
  }

  public getInvisibleAdminsInBot(): AdminInBot[] {
    if (this.socketAdminService.adminsAreCurrentlyHere.length > this.displayableBubbles) return this.socketAdminService.adminsAreCurrentlyHere.filter(admins => admins.position == this.position()).slice(this.displayableBubbles);
    return [];
  }

  public getInvisibleAdminNames(): string {
    if (this.socketAdminService.adminsAreCurrentlyHere.length > this.displayableBubbles) {
      const invisibleAdmins = this.socketAdminService.adminsAreCurrentlyHere.filter(admins => admins.position == this.position()).slice(this.displayableBubbles);
      let invisibleAdminNames: string = '';
      for (const invisibleAdmin of invisibleAdmins) {
        invisibleAdminNames += invisibleAdmin.adminName + '<br>';
      }
      return invisibleAdminNames;
    }
    return '';
  }

  public getInvisibleAdminName(): AdminInBot {
    if (this.socketAdminService.adminsAreCurrentlyHere.length > this.displayableBubbles) {
      const invisibleAdmin = this.socketAdminService.adminsAreCurrentlyHere.filter(admins => admins.position == this.position()).slice(this.displayableBubbles).at(0);
      if (invisibleAdmin) return invisibleAdmin;
    }
    return { adminId: '', adminName: '', position: '' };
  }

  public getAdminNameShort(name: string): string {
    const split = name.split(" ");
    if (split.length === 1) {
      return "" + split.at(0)?.charAt(0);
    } else {
      return "" + split.at(0)?.charAt(0) + split.at(-1)?.charAt(0);
    }
  }

  public getBubbleColor(index: number): string {
    return '' + this.bubbleColor[index % 6];
  }
}
